import SectionMessage from '@atlaskit/section-message';
import { Box } from '@fuegokit/react';

import { useJiraContext } from '../../screens/JiraContextProvider';
import { JiraUser } from '../../types';
import { Link } from './LastEntryDetails';
import { UserDetails } from './UserDetails';
import { getDisplayName } from './utils';

export function DisabledTrackingUser({ user }: { user: JiraUser }) {
  const displayName = getDisplayName(user);
  const { baseUrl } = useJiraContext();
  const userProfileLink = `${baseUrl}/jira/people/${user.accountId}`;
  return (
    <UserDetails user={user}>
      <Box
        bg="var(--ds-background-warning, #FFFAE6);"
        display="flex"
        flex="1"
        alignItems="center"
      >
        <SectionMessage title="Sharing disabled" appearance="warning">
          <span>
            User tracking is disabled due to privacy settings. Please ask{' '}
            <Link href={userProfileLink} target="_blank">
              {displayName}
            </Link>{' '}
            to{' '}
            <Link
              target="_blank"
              href="https://apps.appf.re/toggl/docs/sharing"
              rel="noreferrer noopener"
            >
              activate sharing tracking status
            </Link>
            .
          </span>
        </SectionMessage>
      </Box>
    </UserDetails>
  );
}
